import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EntryApiAdapter } from '../../adapters';

// Instancias singleton
const httpClient = createHttpClient(apiClientWH);
const entryApiAdapter = new EntryApiAdapter(httpClient);

/**
 * Custom hook para cancelar una entrada pendiente
 */
export const useCancelEntry = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (entryId: number) => {
            return entryApiAdapter.cancelEntry(entryId);
        },
        onSuccess: () => {
            // Invalidar queries relacionadas para actualizar la lista
            queryClient.invalidateQueries({
                queryKey: ['entries']
            });
            queryClient.invalidateQueries({
                queryKey: ['entry']
            });
            queryClient.invalidateQueries({
                queryKey: ['entries-count']
            });
        },
        onError: (error: Error) => {
            console.error('❌ Error al cancelar entrada:', error);
        }
    });
};

